import { memo } from 'react';
export var memoize = function (Component, displayName) {
    var memoized = memo(Component);
    memoized.displayName = displayName;
    return memoized;
};
